// Next
import Script from "next/script";

const SchemaScript = () => {
    const jsonLd = {
            "@context": "http://schema.org",
            "@type": "WebSite",
            "name": "Altalex Formazione",
            "url": "https://shop.altalex.com",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://shop.altalex.com/formazione?query={search_term_string}",
                "query-input": "required name=search_term_string"
            }
    };

    return (
        <Script id={"schema-script"} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} strategy={"beforeInteractive"}/>
    );
}

export default SchemaScript;
